/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingReason } from './';
import {
    SourcingReasonFromJSON,
    SourcingReasonFromJSONTyped,
    SourcingReasonToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingStatus
 */
export interface SourcingStatus {
    /**
     * 
     * @type {boolean}
     * @memberof SourcingStatus
     */
    eligible: boolean;
    /**
     * 
     * @type {Array<SourcingReason>}
     * @memberof SourcingStatus
     */
    reasons?: Array<SourcingReason>;
}

/**
 * Check if a given object implements the SourcingStatus interface.
 */
export function instanceOfSourcingStatus(value: object): value is SourcingStatus {
    if (!('eligible' in value) || value['eligible'] === undefined) return false;
    return true;
}

export function SourcingStatusFromJSON(json: any): SourcingStatus {
    return SourcingStatusFromJSONTyped(json, false);
}

export function SourcingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'eligible': json['eligible'],
        'reasons': json['reasons'] == null ? undefined : ((json['reasons'] as Array<any>).map(SourcingReasonFromJSON)),
    };
}

export function SourcingStatusToJSON(value?: SourcingStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eligible': value['eligible'],
        'reasons': value['reasons'] == null ? undefined : ((value['reasons'] as Array<any>).map((v) => SourcingReasonToJSON(v))),
    };
}

